<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';

const route = useRoute();
const defaultTitle = '人才认证考试报名管理后台';
const documentTitle = computed(() => {
  const routeTitle = route.meta.autoSetTitle === false ? '' : (typeof route.meta.title === 'string' ? route.meta.title : '');

  if (routeTitle) {
    return `${routeTitle} - ${defaultTitle}`;
  }

  return defaultTitle;
});

useHead({
  title: documentTitle,
});

zhCN.datePicker.ok = '确认';
</script>

<template>
  <AConfigProvider :locale="zhCN">
    <RouterView />
  </AConfigProvider>
</template>
